/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_SessionInputs */

const th_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชันผู้ดูแลระบบ`)
};

const en_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`admin session`)
};

const ja_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者セッション`)
};

const zh_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员会话`)
};

const es_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sesión de administrador`)
};

const pt_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sessão de administrador`)
};

const id_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi admin`)
};

const fr_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`session administrateur`)
};

const tl_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesyon ng admin`)
};

const vi_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên quản trị`)
};

const ko_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리자 세션`)
};

const de_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Sitzung`)
};

const ru_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сессия администратора`)
};

const tr_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönetici oturumu`)
};

const it_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessione amministratore`)
};

const pl_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesja administratora`)
};

const uk_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сесія адміністратора`)
};

const hi_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यवस्थापक सत्र`)
};

const ar_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلسة المشرف`)
};

const ms_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi pentadbir`)
};

const bn_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রশাসক সেশন`)
};

const zh_tw2_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者工作階段`)
};

const zh_hk2_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者工作階段`)
};

const ur_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتظم سیشن`)
};

const fa_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشست مدیر`)
};

const sw_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kipindi cha msimamizi`)
};

const nl_admin_session = /** @type {(inputs: Admin_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheerderssessie`)
};

/**
* | output |
* | --- |
* | "admin session" |
*
* @param {Admin_SessionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_session = /** @type {((inputs?: Admin_SessionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_SessionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_session(inputs)
	if (locale === "ja") return ja_admin_session(inputs)
	if (locale === "zh") return zh_admin_session(inputs)
	if (locale === "es") return es_admin_session(inputs)
	if (locale === "pt") return pt_admin_session(inputs)
	if (locale === "id") return id_admin_session(inputs)
	if (locale === "fr") return fr_admin_session(inputs)
	if (locale === "tl") return tl_admin_session(inputs)
	if (locale === "vi") return vi_admin_session(inputs)
	if (locale === "ko") return ko_admin_session(inputs)
	if (locale === "de") return de_admin_session(inputs)
	if (locale === "ru") return ru_admin_session(inputs)
	if (locale === "tr") return tr_admin_session(inputs)
	if (locale === "it") return it_admin_session(inputs)
	if (locale === "pl") return pl_admin_session(inputs)
	if (locale === "uk") return uk_admin_session(inputs)
	if (locale === "hi") return hi_admin_session(inputs)
	if (locale === "ar") return ar_admin_session(inputs)
	if (locale === "ms") return ms_admin_session(inputs)
	if (locale === "bn") return bn_admin_session(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_session(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_session(inputs)
	if (locale === "ur") return ur_admin_session(inputs)
	if (locale === "fa") return fa_admin_session(inputs)
	if (locale === "sw") return sw_admin_session(inputs)
	if (locale === "nl") return nl_admin_session(inputs)
	return en_admin_session(inputs)
});